import React from "react"

const HamburgerItem = ({ onClick, showNavList }) => (
  <button
    className={`navbar-toggler btn-nav_toggle ${
      showNavList ? "" : "collapsed"
      }`}
    type="button"
    data-toggle="collapse"
    data-target="#navbarNavDropdown"
    aria-controls="navbarNavDropdown"
    aria-expanded={showNavList ? "true" : "false"}
    aria-label="Toggle navigation"
    onClick={onClick}
  >
    <span className="icon-bar top-bar" />
    <span className="icon-bar middle-bar" />
    <span className="icon-bar bottom-bar" />
  </button>
)

export default HamburgerItem;
